import React from 'react';

const SampleOrders = () => {
  return <>Samplings - Sample Order Screen</>;
};

export default SampleOrders;
